import { createContext, useContext, useState, useCallback } from 'react';

const SyncContext = createContext();

export const useSyncContext = () => {
  const context = useContext(SyncContext);
  if (!context) {
    throw new Error('useSyncContext must be used within a SyncProvider');
  }
  return context;
};

// eslint-disable-next-line react/prop-types
export const SyncProvider = ({ children }) => {
  const [syncTrigger, setSyncTrigger] = useState(0);
  const [lastSyncTime, setLastSyncTime] = useState(null);
  const [syncStatus, setSyncStatus] = useState({
    isInitialSyncComplete: false,
    isManualSyncInProgress: false,
    lastSyncResult: null
  });

  // Function to trigger a sync refresh across all components
  const triggerSyncRefresh = useCallback(() => {
    setSyncTrigger(prev => prev + 1);
    setLastSyncTime(new Date());
  }, []);

  // Function to update sync status
  const updateSyncStatus = useCallback((status) => {
    setSyncStatus(prev => ({ ...prev, ...status }));
  }, []);

  // Function to mark initial sync as complete
  const markInitialSyncComplete = useCallback((result = null) => {
    setSyncStatus(prev => ({
      ...prev,
      isInitialSyncComplete: true,
      lastSyncResult: result
    }));
    triggerSyncRefresh();
  }, [triggerSyncRefresh]);

  const value = {
    syncTrigger,
    lastSyncTime,
    syncStatus,
    triggerSyncRefresh,
    updateSyncStatus,
    markInitialSyncComplete
  };

  return (
    <SyncContext.Provider value={value}>
      {children}
    </SyncContext.Provider>
  );
};

export default SyncContext;